import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Background from "../../components/common/Background";
import Main from "./Maininfo";
import Footer from "../../components/common/utils/Footer";
import * as empActions from "../../redux/actions/empActions";
import * as attendanceActions from "../../redux/actions/Attendance/attendanceActions";
import Modal from "react-bootstrap/lib/Modal";
import Charts from "../../feature/attendance/charts";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";
import {hashHistory} from "react-router";


let to = new Date();


let monDate = new Date();

let z1 = monDate.getDay() - 1;
if (z1 > 0)
  monDate.setDate(monDate.getDate() - z1);
else if (z1 == 0)
  monDate.setDate(monDate.getDate() - 7);
else
  monDate.setDate(monDate.getDate() - 7 + 1);

var default_search = {
  startDate: monDate,
  endDate: to,
  pageNo: 0
};

class HomePage extends React.Component {

  constructor() {
    super();
    this.state = ({data: [], series: [], show: false})
    this.getChartData = this.getChartData.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  open() {
    this.setState({show: true})
  }

  close() {
    this.setState({show: false})
  }

  toSeconds(time) {
    var parts = time.split(':');
    return (+parts[0]) * 60 * 60 + (+parts[1]) * 60 + (+parts[2]);
  }

  toHHMMSS(sec) {
    var sec_num = parseInt(sec, 10); // don't forget the second parm
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    var time = hours + ':' + minutes + ':' + seconds;
    return time;
  }

  getChartData(attendance) {
    let data = new Array();
    let series = new Array();
    attendance.map((attendanceData, index)=> {
      data[index] = new Array();
      let hrs = 0, mins = 0;
      if (attendanceData.totalWorkingHour != null) {
        hrs = parseInt(attendanceData.totalWorkingHour.substr(0, 2));
        mins = parseInt(attendanceData.totalWorkingHour.substr(3, 2));
      }
      data[index][0] = hrs + mins / 100;
      if (attendanceData.date != null)
        series[index] = attendanceData.date.substr(0, 6);
    });


    this.setState({data: data, series: series});
  }

  componentDidMount() {
    this.props.dispatch(empActions.store());
    this.props.dispatch(attendanceActions.getAttendance(default_search));
  }

  componentWillReceiveProps(props) {
    if (props.attendance.empId != null) {
      this.getChartData(props.attendance.attendance);
    }
  }

  refresh() {
    this.props.dispatch(empActions.store())
  }

  render() {
    let totalHours = 0;
    for (var attendance in this.props.attendance.attendance) {
      if (this.props.attendance.attendance[attendance].totalWorkingHour != null)
        totalHours += this.toSeconds(this.props.attendance.attendance[attendance].totalWorkingHour)
    }
    totalHours = this.toHHMMSS(totalHours);
    return (
      <div>
        <Background loading={this.props.loading}/>
        <section className="home">
          <div className="container">
            <Main
              openAttendance={this.open}
              emp={this.props.emp_info[0]} name={this.props.name} stopLoad={this.props.stopLoad}/>
          </div>
        </section>

        <div style={{marginTop: '5%'}}>


          <Modal show={this.state.show} onHide={this.close}>
            <Modal.Header closeButton>
              <Modal.Title>Attendance: {default_search.startDate.toDateString()}
                - {default_search.endDate.toDateString()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div >

                <p>Average Working Hours: {this.props.attendance.avgWorkHours}</p>
                <p>Total Working Hours: {totalHours}</p>
                <Charts height="200" chartHeight="150" data={this.state.data} series={this.state.series}/>
                <BootstrapTable height="230"
                                containerStyle={{paddingTop: 0}}
                                data={this.props.attendance.attendance} striped={false} hover={true} condensed={true}>
                  <TableHead dataSort={true}
                             columnClassName="attendancerowX"


                             isKey={true} width={"130"} dataField="date">Date</TableHead>
                  <TableHead dataSort={true}
                             columnClassName="attendancerowX"

                             width={"110"} dataField="startTime" dataFormat={this.checkNull}>In Time</TableHead>
                  <TableHead dataSort={true}
                             columnClassName="attendancerowX"

                             dataFormat={this.checkNull}
                             width={"110"}
                             dataField="endTime">Out Time</TableHead>

                  <TableHead dataField="totalWorkingHour"
                             columnClassName="attendancerowX"

                             dataFormat={this.checkNull}
                             dataSort={true}
                             width={"120"}>Working Hrs</TableHead>

                </BootstrapTable>
              </div>
              <hr/>
              <button
                onClick={()=> {
                  hashHistory.push("/1/attendance");
                }}
                className="btn btn-block btn-default">View Attendance
              </button>
            </Modal.Body>
          </Modal>


          <Footer/>
        </div>
      </div>
    );
  }

}

HomePage.propTypes = {
  roles: React.PropTypes.object,
  emp_info: React.PropTypes.array,
  stopLoad: React.PropTypes.func,
  dispatch: React.PropTypes.func.isRequired,
  name: React.PropTypes.string
};
function mapStateToProps(state, ownProps) {
  return {

    emp_info: state.emp, loading: state.ajaxCallsInProgress,
    attendance: state.attendance[0].attendance

  };

}

export default connect(mapStateToProps)(HomePage);







/** WEBPACK FOOTER **
 ** ./src/components/Home/Home.js
 **/